module.exports = __webpack_public_path__ + "static/media/text.3ffa9a26.png";